<template>
	<div class="mood-stream">
		<div class="mood-calendar-wrapper">
			<transition name="slide">
				<div
					v-show="showEmotionCard"
					class="emotion-card"
				>
					<emotion-card
						title="Current Emotion"
						:sticker="daily.filepath"
						:bpm="daily.heartbeat_count"
						:stress="daily.stress_level"
						:mood="daily.emotion_value"
						:moodDate="moodDate"
						:percent="dailyPercentage"
					></emotion-card>

					 <span
						class="close"
						@click="showEmotionCard=false"
						v-if="showEmotionCard"
					 >
						&#11164;
					 </span>
				</div>
			</transition>

			<custom-calendar
				v-model="calendarDate"
				@click="showCard"
				@month-change="getCalendar"
			>
				<template #day="{ day }">
					<div class="mood">
						<div
							v-if="calendarMoods[day.value]"
							class="sticker bg-contain"
							:style="`background-image: url('${URL}img/resources/${calendarMoods[day.value]}')`"
						>
						</div>

						<span>{{ day.value }}</span>
					</div>
				</template>
			</custom-calendar>
		</div>

		<data-container
			class="mood-stream-data"
			title="Mood Stream"
		>
			<template #controls>
				<p>{{ moodDate }}</p>
			</template>
			<template #content>
				<custom-table
					:fields="fields"
					:items="history"
					:is-selectable="false"
					:has-pagination="false"
					:is-loading="historyLoading"
				>
					<template #time="{ item }">
						<span>{{ item.time_created | time('h:mm') }}</span>
					</template>

					<template #emotion="{ item }">
						<div
							class="emotion bg-contain"
							:style="`background-image: url('${URL}img/resources/${item.filepath}')`"
						>
						</div>
						<p>{{ item.emotion }}</p>
					</template>

				</custom-table>
			</template>
		</data-container>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import DataContainer from '@/components/layouts/DataContainer.vue'
import CustomTable from '@/components/utils/CustomTable.vue'
import CustomCalendar from '@/components/utils/CustomCalendar.vue'
import EmotionCard from '@/components/utils/EmotionCard.vue'

export default {
	props: ['id'],

	created () {
		this.getDaily(new Date())
		this.getCalendar(new Date())
	},

	computed: {
		calendarMoods () {
			const { filters } = this.$options
			return this.calendar.reduce((values, current) => {
				const date = filters.dateFormatter(current.date, 'D')
				values[date] = current.filepath
				return values
			}, {})
		},

		dailyPercentage () {
			return parseInt(`${this.daily.upmood_meter + 1}0`)
		},

		moodDate () {
			const { filters } = this.$options
			let date = this.calendarDate

			if (!this.calendarDate) {
				date = new Date()
			}

			return filters.dateFormatter(date, 'MMMM D, YYYY')
		},

		...mapGetters('user', {
			calendar: 'getCalendar',
			calendarLoading: 'getCalendarLoading',
			daily: 'getDaily',
			dailyLoading: 'getDailyLoading',
			history: 'getHistory',
			historyLoading: 'getHistoryLoading'
		}),

		...mapFields('user', {
			calendarDate: 'calendarDate'
		})
	},

	data () {
		return {
			URL: process.env.VUE_APP_BASE,
			showEmotionCard: false,

			fields: [
				{ name: 'time', text: 'Time' },
				{ name: 'heartbeat_count', text: 'BPM' },
				{ name: 'ppi', text: 'No of PPI' },
				{ name: 'total_ppi', text: 'Total Sum' },
				{ name: 'stress_level', text: 'Stress Level' },
				{ name: 'emotion', text: 'Emotion' },
				{ name: 'profile_post', text: 'User Status' }
			]
		}
	},

	methods: {
		dateFormatter (date, format = 'YYYY-MM-DD') {
			const { filters } = this.$options
			return filters.dateFormatter(date, format)
		},

		showCard (date) {
			this.getDaily(date)
			this.showEmotionCard = true
		},

		getDaily (date = null) {
			let calendarDate = this.calendarDate

			if (date) {
				calendarDate = date
			}

			calendarDate = this.dateFormatter(calendarDate)

			const dailyParams = `?id=${this.id}&date=${calendarDate}`

			this.$store.dispatch('user/getDailyCalendar', dailyParams)

			if (!date) {
				this.getHistory(this.calendarDate)
			}
		},

		getHistory (date = null) {
			let selectedDate = this.calendarDate
			let query = `?id=${this.id}`

			if (date) {
				selectedDate = date
			}

			if (selectedDate) {
				selectedDate = this.dateFormatter(selectedDate)
				query += `&date=${selectedDate}`
			}

			this.$store.dispatch('user/getHistory', query)
		},

		getCalendar (e) {
			const currentDate = this.dateFormatter(e, 'YYYY-MM')
			const calendarParams = `?id=${this.id}&date=${currentDate}`

			this.$store.dispatch('user/getCalendar', calendarParams)
		}
	},

	components: {
		DataContainer,
		CustomTable,
		CustomCalendar,
		EmotionCard
	}
}
</script>

<style lang="scss" scoped>
.mood-stream {
	flex: 1 1 auto;
	padding: 10px 0;
	width: 100%;
	height: 100%;
	@include flex-row;
}

/deep/ .mood-stream-data {
	flex: 1 1 auto;
	height: 100%;
	margin-left: 20px;
	border: 1px solid $light;

	td {
		.emotion {
			height: 60px;
			width: 60px;
		}

		p {
			text-align: center;
			padding: 5px;
			width: 60px;
		}
	}
}

/deep/ .custom-table table tr td {
	text-transform: capitalize;
}

.mood-calendar-wrapper {
	flex: 1 1 auto;
	min-width: 400px;
	max-height: 450px;
	position: relative;
	overflow: hidden;

	.emotion-card {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 2;

		.close {
			position: absolute;
			right: 10px;
			top: 0;
			z-index: 3;
			font-size: 24px;
			color: $primary;
			cursor: pointer;
		}
	}

	/deep/ .custom-calendar {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;

		tbody td {
			padding: 0;
		}

		.mood {
			position: relative;
			height: 100%;
			padding: 14px 5px 5px 5px;
			pointer-events: none;

			span {
				position: absolute;
				top: 0;
				left: 0;
				display: inline-block;
				height: 24px;
				width: 24px;
				@include flex-row(center,center);
				transition: 0.3s;
			}

			.sticker {
				height: 100%;
				width: 100%;
			}
		}

		td {
			&.selected {
				.mood span {
					background-color: $primary;
					color: #fff;
					border-radius: 50%;
					font-weight: 400;
				}
			}
		}
	}
}
</style>
